import { useEffect, useRef } from "react";

/** What dragging across a table's tick tiles is setting: true, false, or null when not dragging. Shared by
 * every TickTile in the table, and cleared when the button or finger lifts anywhere. */
export function useTickDrag() {
  const paint = useRef<boolean | null>(null);
  useEffect(() => {
    const stop = () => (paint.current = null);
    window.addEventListener("pointerup", stop);
    window.addEventListener("pointercancel", stop);
    return () => {
      window.removeEventListener("pointerup", stop);
      window.removeEventListener("pointercancel", stop);
    };
  }, []);
  return paint;
}
